import React from "react";

const StaffApp = () => {
  return (
    <div className="flex-col flex-1 w-full h-full radius-10 back-white  align-center justify-center  pt-2 pb-2 pl-3 pr-3 g-2">
      <h3 className="t-18 color-borderGray poppins-medium weight-500">
        Here is nothing to be controll in this version
      </h3>
    </div>
  );
};

export default StaffApp;
